<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page title="Kaunter : Buka Kaunter">
            <div class="message-box">
                <w-transition-fade>
                    <w-alert
                        class="my0 text-light"
                        v-if="form.submitted"
                        success
                        no-border
                    >
                        The form is valid, ready to send it!
                    </w-alert>

                    <w-alert
                        class="my0 text-light"
                        v-else-if="form.valid === false"
                        error
                        no-border
                    >
                        Terdapat {{ form.errorsCount }} ralat di dalam borang
                        ini.
                    </w-alert>
                </w-transition-fade>
            </div>

            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="onValidate"
                @success="onSuccess"
            >
                <w-flex justify-center align-center class="table-hardcode">
                    <loading v-model:active="isLoading"
                    :can-cancel="false"
                    :opacity="0.7"
                    :is-full-page="false"/>
                    <div class="w-card__content content-hardcode">
                        <z-table
                            ref="tbluser"
                            title=""
                            :headers="table.headers"
                            :items="table.items"
                            :meta="table.meta"
                            class=""
                        >
                            <template #button> </template>
                            <template #header-label="{ header, label, index }">
                                <template v-if="header.key == 'action'">
                                    Tindakan
                                </template>
                            </template>
                            <template
                                #item-cell.action="{
                                    item,
                                    label,
                                    header,
                                    index,
                                }"
                            >
                                <w-flex class="flex justify-center">
                                    <w-icon tile @click="edit(item)"
                                        >fal fa-pencil</w-icon
                                    >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <w-icon class="mr1" @click="editPtg(item)"
                                        >fal fa-plus</w-icon
                                    >
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <w-icon dark tile @click="destroy(item)"
                                        >fal fa-trash</w-icon
                                    >
                                </w-flex>
                            </template>
                            <template
                                #item-cell.action_buka="{
                                    item,
                                    label,
                                    header,
                                    index,
                                }"
                            >
                                <w-flex class="flex justify-center">
                                    <template v-if="item.ind_buka == 1 && item.lkp_kaunter_status_id == 2">
                                        <template
                                            v-if="$zutil.can('Kaunter Buka')"
                                        >
                                            <w-button
                                                class="ml1"
                                                @click="send(1, item)"
                                                :disabled="form.valid === false || form.loading"
                                                :loading="form.loading"
                                            >
                                                Buka
                                            </w-button>
                                        </template>
                                    </template>
                                    <!-- <template v-else>
                              <template v-if="item.user_id == $page.props.auth.user.id">
                              <w-button class="ml1 " @click="send(2, item)">
                                   Tutup
                                </w-button>
                              </template>
                            </template> -->
                                </w-flex>
                            </template>
                        </z-table>
                    </div>
                </w-flex>

                <!-- <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                    <w-icon dark tile >fal fa-save</w-icon>
                </w-button>
            </w-flex> -->
            </w-form>

            <w-notification
                v-model="form.sent"
                success
                transition="bounce"
                absolute
                plain
                round
                bottom
            >
                Borang telah berjaya dihantar
            </w-notification>
        </z-page>
        <w-overlay
              v-model="showOverlay"
              :persistent= true>
              
            <center v-if="form.loading"><w-progress class="ma1" circle></w-progress></center>
        </w-overlay>
    </zen-one>
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import ZResource from "@/Modules/z-resource-service";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    extends: ZResource,
    components: {
        Vue3ChartJs,
        Loading,
    },
    setup() {
        const doughnutChart = {
            id: "doughnut",
            type: "doughnut",
            data: {
                labels: ["VueJs", "EmberJs", "ReactJs", "AngularJs"],
                datasets: [
                    {
                        backgroundColor: [
                            "#37479e",
                            "#2f3d88",
                            "#273371",
                            "#1f285a",
                        ],
                        data: [40, 20, 80, 10],
                    },
                ],
            },
            options: { plugins: { legend: { display: false } } },
        };

        const beforeRenderLogic = (event) => {
            //...
            //if(a === b) {
            //  event.preventDefault()
            //}
        };

        return {
            doughnutChart,
            beforeRenderLogic,
        };
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "kaunter",

            dialog: {
                show: false,
                show2: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 500,
            },
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
                loading: false,
            },
            validators: {
                required: (value) => !!value || "This field is required",
                consent: (value) => !!value || "You must agree",
            },
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Kaunter", route: "/kaunter" },
                { label: "Buka Kaunter", route: "/Kaunter/buka" },
            ],
            showCard: false,
            isLoading: true,
            showOverlay: false,
        };
    },
    watch: {
        table(){
            this.isLoading = false
        }
    },
    methods: {
        onSuccess() {
            setTimeout(() => (this.form.sent = true), 2000);
            this.$inertia.visit(window.route("kutipan.kaunter.sementara"));
        },
        onValidate() {
            this.form.sent = false;
            this.form.submitted = this.form.errorsCount === 0;
        },

        // send(status, item) {
        //     this.form.lkp_kaunter_status_id = status;
        //     this.form.id = item.id;
        //     this.$zcomm
        //         .update(
        //             this.service_kutipan + "kaunter" + "/" + this.form.id,
        //             this.form.id,
        //             this.form
        //         )
        //         .then((res) => {
        //             this.$zutil.notify("Kaunter Berjaya Dibuka");
        //             this.$inertia.visit(this.$route("kutipan.kaunter.buka"));
        //         })
        //         .catch((err) => {})
        //         .finally(() => {});
        // },

        send(status, item) {
            if (this.form.loading) return; // cegah klik berkali-kali

            this.form.loading = true; // mulai loading

            this.form.lkp_kaunter_status_id = status;
            this.form.id = item.id;
            this.showOverlay= true

            this.$zcomm
                .update(
                    this.service_kutipan + "kaunter" + "/" + this.form.id,
                    this.form.id,
                    this.form
                )
                .then((res) => {
                    this.$zutil.notify("Kaunter Berjaya Dibuka");
                    this.$inertia.visit(this.$route("kutipan.kaunter.buka"));
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    this.form.loading = false; // stop loading
                    this.showOverlay= false;
                });
        },

    },
};
</script>

<style></style>
